/* eslint-disable react/no-array-index-key */
/* eslint-disable no-bitwise */
import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useGetDashboardGroupedDataQuery } from '../services/dashboard.endpoints';

const UsersByHostAppChart = () => {
  const { data, error, isLoading } = useGetDashboardGroupedDataQuery();
  console.log('UsersByHostAppChart', error);

  if (isLoading) return <CircularProgress />;
  if (error) return <Typography>Error loading data</Typography>;

  const usersByHostAppData = data?.usersByHostApp || [];

  return (
    <Box>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={usersByHostAppData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="_id" tick={{ fontSize: 12 }} />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Bar dataKey="userCount" fill="#2B61AA" />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default UsersByHostAppChart;
